import { areaOfClosedPolygon, polygonPerimeter } from "@faro-lotv/lotv";
import { convertIElementToThreePosition } from "@faro-lotv/project-source";
import { Matrix4, Vector3 } from "three";

/**
 * Get the coordinates string "x, y, z" in Z-up for a given point in ProjectAPI-Y-up
 *
 * @param point the given coordinate in Y-up
 * @returns a point of the coordinates in Z-up.
 */
export function getCoordinateZUp(point) {
  return {
    x: point.x,
    y: point.z,
    z: point.y
  };
}

/** Props for the `getMeasurements` function */

/** Return object of the `getMeasurements` function */

/**
 * Gets the measurement values from a series of 3D points
 * @returns An object with the measurement values in meters (or square meters for area)
 */
export function getMeasurements({
  localPoints,
  isClosed,
  worldMatrix4Tuple
}) {
  const worldMatrix4 = new Matrix4().fromArray(worldMatrix4Tuple);

  // Convert each local 3D point to a Vector3 in world space.
  const worldPoints = localPoints.map(localPoint => {
    const worldPoint = new Vector3()
    // Convert each point from left-handed coordinate system (ProjectAPI Y-up)
    // to right-handed coordinate system (ThreeJS Z-up)
    .fromArray(convertIElementToThreePosition(localPoint)).applyMatrix4(worldMatrix4);
    return worldPoint;
  });
  const length = polygonPerimeter(worldPoints, isClosed);
  const area = isClosed ? areaOfClosedPolygon(worldPoints).area : undefined;
  let horizontal = undefined;
  let vertical = undefined;
  let x = undefined;
  let y = undefined;
  let z = undefined;
  if (worldPoints.length === 2) {
    const [p1, p2] = worldPoints;
    horizontal = new Vector3(p1.x, p2.y, p1.z).distanceTo(new Vector3(p2.x, p2.y, p2.z));
    vertical = new Vector3(p1.x, p1.y, p1.z).distanceTo(new Vector3(p1.x, p2.y, p1.z));
    x = new Vector3(p1.x, p2.y, p2.z).distanceTo(new Vector3(p2.x, p2.y, p2.z));
    y = new Vector3(p1.x, p2.y, p1.z).distanceTo(new Vector3(p1.x, p2.y, p2.z));
    z = new Vector3(p1.x, p1.y, p1.z).distanceTo(new Vector3(p1.x, p2.y, p1.z));
  }
  return {
    length,
    area,
    horizontal,
    vertical,
    x,
    y,
    z
  };
}